import { useContext, useState } from "react";
import { PopOverMenu } from "components/commons";
import { locale } from "localization/en";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styles from "./shift-records.module.scss";
import { FormMode, Path, ShiftStatus } from "enums";
import { validateShiftByShiftId } from "apis/shift-records.api";
import { useApi } from "hooks";
import { FeatureFlagContext } from "contexts";

const ValidatedPopOverMenu = ({
  shifts,
  history,
  syncPercentage,
  showPrevModal,
  showSyncModal,
  showReopenModal,
  isRecentClosedShift,
}) => {
  const [menuOptions, setMenuOptions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const { shiftId, status } = shifts;
  const { hasFeature } = useContext(FeatureFlagContext);

  const { request: validationRequest } = useApi({
    api: validateShiftByShiftId,
    handleOwnError: true,
    params: {
      shiftId,
    },
  });

  const validatedOptions = [
    {
      content: locale.viewDetails,
      onClick: () => {
        history.push(Path.ViewShiftDetailsInfoById(shiftId, FormMode.View));
      },
    },
  ];

  const handleTriggerClick = async (event) => {
    const el = event.currentTarget;
    try {
      await validationRequest();
      if (status === ShiftStatus.Ended) {
        validatedOptions.push({
          content: locale.editDetails,
          onClick: () => {
            history.push(Path.ViewShiftDetailsInfoById(shiftId, FormMode.Edit));
            // if (syncPercentage >= 100) {
            //   history.push(Path.ViewShiftDetailsInfoById(shiftId, FormMode.Edit));
            // } else {
            //   return showSyncModal();
            // }
          },
        });
      }
    } catch (error) {
      if (status === ShiftStatus.Ended) {
        validatedOptions.push({
          content: locale.editDetails,
          onClick: () => {
            showPrevModal();
          },
        });
      }
    }

    if (status === ShiftStatus.Closed && isRecentClosedShift && hasFeature("REOPEN_SHIFT")) {
      validatedOptions.push({
        content: locale.reopenShift,
        onClick: () => {
          showReopenModal(shiftId);
        },
      });
    }

    setMenuOptions(validatedOptions);
    setAnchorEl(el);
  };

  return (
    <PopOverMenu
      options={menuOptions}
      disabledClick={true} // Disable automatic open
      setActiveClicked={setAnchorEl} // Manually control anchor
      externalAnchorEl={anchorEl}
    >
      <div onClick={handleTriggerClick}>
        <MoreVertIcon className={styles.icon} />
      </div>
    </PopOverMenu>
  );
};

export default ValidatedPopOverMenu;
